const keepOnlyUpcaseLettersAndBlankSpace = text => {
  return text.replace(/[^A-zÀ-ú'\s]+/g, '')
}

const keepOnlyNumbers = text => {
  return text.replace(/\D/g, '')
}

const limit = (text, max) => {
  return `${text}`.substring(0, max)
}

const removeBlankSpaces = text => {
  return text.replace(/\s/g, '')
}

const upcase = text => {
  return `${text}`.toUpperCase()
}

const lowcase = text => {
  return `${text}`.toLowerCase()
}

const toString = any => {
  return `${any}`
}

const formatCpf = text => {
  const digits = keepOnlyNumbers(text || '')

  if (digits.length !== 11) return text || ''

  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

const strings = {
  keepOnlyUpcaseLettersAndBlankSpace,
  keepOnlyNumbers,
  limit,
  removeBlankSpaces,
  upcase,
  lowcase,
  toString,
  formatCpf,
}
export default strings
